import { CONTACT, NAV_LINKS } from "../lib/data";
import { scrollToId } from "../lib/smoothScroll";

const FOOTER_LINKS = NAV_LINKS.filter((l) => l.id !== "why-us");
const FOOTER_SERVICES = [
  "Mobile Application Development",
  "Web Application Development",
  "Website Development",
];

export const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer
      className="relative border-t border-border-subtle bg-card-dark/60 pt-14 sm:pt-16 pb-8"
      data-testid="site-footer"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="font-mono text-laser text-lg font-medium">{"</>"}</span>
              <span className="font-display font-extrabold text-lg tracking-wide">
                <span className="text-white">DOTNET</span>
                <span className="text-electric">SERVICES</span>
              </span>
            </div>
            <p className="text-slate-400 text-sm leading-relaxed">
              Building mobile applications, web applications, and professional websites for
              businesses, startups, and entrepreneurs.
            </p>
            <p className="mt-4 font-mono text-xs text-slate-500">dotnetservices</p>
          </div>

          <div>
            <h4 className="text-white font-semibold text-sm mb-4">Quick Links</h4>
            <ul className="space-y-2.5">
              {FOOTER_LINKS.map((link) => (
                <li key={link.id}>
                  <button
                    onClick={() => scrollToId(link.id)}
                    data-testid={`footer-${link.id}-link`}
                    className="text-slate-400 hover:text-laser text-sm transition-colors duration-200"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold text-sm mb-4">Services</h4>
            <ul className="space-y-2.5">
              {FOOTER_SERVICES.map((s) => (
                <li key={s} className="text-slate-400 text-sm">
                  {s}
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold text-sm mb-4">Contact</h4>
            <ul className="space-y-2.5 text-sm">
              <li>
                <a
                  href={CONTACT.phoneLink}
                  data-testid="footer-phone-link"
                  className="text-slate-400 hover:text-laser transition-colors"
                >
                  {CONTACT.phoneDisplay}
                </a>
              </li>
              <li>
                <a
                  href={CONTACT.emailLink}
                  data-testid="footer-email-link"
                  className="text-slate-400 hover:text-laser transition-colors break-all"
                >
                  {CONTACT.email}
                </a>
              </li>
              <li className="text-slate-400">Balangir, Odisha, India</li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-slate-500 text-xs">
            {"\u00a9"} {year} Dotnet Services. All Rights Reserved.
          </p>
          <p className="font-mono text-xs text-slate-600">dotnetservices</p>
        </div>
      </div>
    </footer>
  );
};
